// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2VZXE","calendarButtons":"ClockData_calendarButtons__sFMGN"};